const StoresDetailsListSkeleton: React.FC<any> = ({ viewRef }) => {
  return (
    <div className="overflow-hidden" ref={viewRef}>
      <div className="enki-heading-lg mb-3 mt-7 w-[140px] h-[24px] bg-surface-200-bg ml-5 skeleton"></div>
      <div className="mx-[-20px]  pl-5">
        {[1].map((item, index) => {
          return (
            <div key={`${index}-${item}`} className="w-unset box-border mt-4" style={{ width: 'auto' }}>
              <div className="p-[10px] box-border text-left">
                <>
                  <div>
                    <div className="w-[140px] h-[24px] bg-surface-200-bg skeleton"></div>
                    <div className="w-[200px] h-[15px] bg-surface-200-bg skeleton mt-[2px]"></div>
                  </div>
                  <div className="mt-[6px]">
                    <div className="w-[125px] h-[17px] bg-surface-200-bg skeleton rounded-600"></div>
                  </div>

                  <div className="flex pt-3 ml-[-10px]">
                    {[1, 2, 3].map((i, idx) => {
                      return (
                        <div className="w-[150px] ml-[10px] flex-shrink-0" key={`${i}-${idx}`}>
                          <div className="rounded-2xl overflow-hidden w-full h-[150px] skeleton bg-surface-200-bg ">
                            <div className="w-full h-full default-img"></div>
                          </div>
                          <div className="w-full h-5 mt-[5px]  bg-surface-200-bg skeleton"></div>
                          <div className="w-1/2 h-5 mt-[5px]  bg-surface-200-bg skeleton"></div>
                        </div>
                      );
                    })}
                  </div>
                </>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StoresDetailsListSkeleton;
